import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import LinkPicker from './LinkPicker.js';
import AlignPicker from './AlignPicker.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';
import FontPicker from './FontPicker.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementHeader from './SidebarElementHeader.js';

import ManufacturerPicker from '../../containers/segments/Rules/ManufacturerPicker';
import CategoryPicker from '../../containers/segments/Rules/CategoryPicker';


class ProductSelection extends React.Component {
    constructor(props) {
        super(props);
        this.el = this.el.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.onButtonChange = this.onButtonChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.rows = this.rows.bind(this);
        this.handleDropDown = this.handleDropDown.bind(this);
        this.onSaleChange = this.onSaleChange.bind(this);

    }

    handleDropDown(type,o,values) {
        let v = [];

        for(let i in values) {
            if(type == 'manufacturers') {
                v.push(values[i].manufacturer);
            }else{
                v.push(values[i].id);
            }

        }
        v = v.join(',');

        if(v == '') {
            v = false;
        }

        this.props.setComponentState(this.el().id,{[type]:v});

    }

    rows() {
        let ret = [];

        for(let i = 1; i<=this.el().rows;i++) {
            ret.push(<tr key={i}>
                {this.productBox()}
                {this.productBox()}
                {this.productBox()}
            </tr>);
        }

        return ret;
    }

    onButtonChange(e) {
        this.props.setComponentState(this.el().id,{'button_text':e.target.value});
    }

    onTextChange(e) {
        this.props.setComponentState(this.el().id,{[e.target.getAttribute('data-id')]:e.target.value});
    }

    onSaleChange(e) {
        let v = !this.el()[e.target.getAttribute('data-id')];

        this.props.setComponentState(this.el().id,{[e.target.getAttribute('data-id')]:v});
    }

    handleChange(id,s) {
        let changes = {};
        changes[id] = s;
        this.props.setComponentState(this.el().id,changes);
    }

    el() {
        return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
        this.props.setSidebarState({'visible':false});
    }

    componentDidMount() {

    }

    productBox() {
        return (
            <td style={{width:'25%',padding:this.el().padding}}>
                <table className="product-box table-block">
                    <tbody>
                    <tr>
                        <td>
                            <img src="https://cdn.crall.io/uploads/test.jpg" />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Product name
                        </td>
                    </tr>
                    <tr>
                        <td>
                            1.232,-
                        </td>
                    </tr>
                    <tr>
                        <td style={{padding:'10px',color:'#fff',backgroundColor:this.el().button_background}}>
                            {this.el().button_text}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </td>
        )
    }

    render() {
        if(this.props.sidebar == true) {
            return(
                <div className="sidebar text product-selection " style={this.props.style}>
                    <SidebarElementHeader handleBackClick={this.handleBackClick} text="Product selection" />

                    <div className="panel-group panel-group-continuous" id="cart-settings" aria-multiselectable="true" role="tablist">


                        <SidebarSettingAccordion selectedSetting={false} optionKey="container" parent="cart-settings" title="Container">


                            <SidebarElementSetting text="Font style">
                                <FontPicker
                                    fontId='text_font'
                                    sizeId='text_size'
                                    colorId='text_color'
                                    font={this.el().text_font}
                                    size={this.el().text_size}
                                    color={this.el().text_color}
                                    handleChange={this.handleChange}
                                />
                            </SidebarElementSetting>

                        </SidebarSettingAccordion>

                        <SidebarSettingAccordion selectedSetting={false} optionKey="container" parent="cart-recommendation" title="Products">
                            <SidebarElementSetting text="Type">
                                <select className="form-control" value={this.el().type} data-id="type" onChange={this.onTextChange} >
                                    <option value="Random">Random</option>
                                    <option value="Bestsellers">Bestsellers</option>
                                </select>
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Must be in category (OR)">
                                <CategoryPicker handleRuleChange={this.handleDropDown} rule={{
                                    value:this.el().categories,
                                    id:this.el().id,
                                }} index="categories" />
                                <p>
                                    Does not match child categories. Each child category must be added separately.
                                </p>
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Must have manufacturer (OR)">
                                <ManufacturerPicker handleRuleChange={this.handleDropDown} rule={{
                                    value:this.el().manufacturers,
                                    id:this.el().id,
                                }} index="manufacturers" />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Minimum product price">
                                <input type="text" placeholder="Minimum price" data-id="min_price" onChange={this.onTextChange} value={this.el().min_price} className="form-control" />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Rows">
                                <select className="form-control" value={this.el().rows} data-id="rows" onChange={this.onTextChange} >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                </select>
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Sort by">
                                <select className="form-control" value={this.el().sort_by} data-id="sort_by" onChange={this.onTextChange} >
                                    <option value="none">No sorting</option>
                                    <option value="newest">Newest</option>
                                    <option value="price_low">Price low -> high</option>
                                    <option value="price_high">Price high -> low</option>
                                </select>
                            </SidebarElementSetting>


                            <SidebarElementSetting text="On sale">
                                <div className="checkbox-custom checkbox-default">
                                    <input type="checkbox" checked={this.el().only_on_sale} data-id="only_on_sale" onChange={this.onSaleChange} />
                                    <label>Only display products on sale</label>
                                </div>
                            </SidebarElementSetting>

                        </SidebarSettingAccordion>

                        <SidebarSettingAccordion selectedSetting={false} optionKey="container" parent="cart-translation" title="Button">

                            <SidebarElementSetting text="Text">
                                <input type="text" value={this.el().button_text} data-id="button_text" onChange={this.onTextChange} className="form-control" />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Background color">
                                <ColorPicker id='button_background' color={this.el().button_background} handleColorChange={this.handleChange} />
                            </SidebarElementSetting>



                        </SidebarSettingAccordion>

                    </div>


                </div>


            );
        }else{
            return (
                <table className="table-block" style={{width:'100%',fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>
                    <tbody>
                    {this.rows()}
                    </tbody>
                </table>

            );
        }

    }
}
const mapStateToProps = (state) => {
    return {
        builder:state.builder
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

ProductSelection = connect(mapStateToProps,mapDispatchToProps)(ProductSelection);

export default ProductSelection;





// WEBPACK FOOTER //
// ./components/builder/ProductSelection.js